<template>
  <v-row dense class="mx-1">
    <v-spacer/>
    <v-btn icon @click="onClickRefresh">
      <v-icon>mdi-refresh</v-icon>
    </v-btn>
    <px-search-text class="rounded-tag-small"
                    label="Busque por uma transportadora ou identificador"
                    style="max-width: 400px"
                    v-model="searchText"
                    :on-search="emitChange"/>
  </v-row>
</template>

<script>
export default {
  props: {
    onClickRefresh: {
      type: Function,
      required: true,
    },
    isComprador: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    searchText: {
      get() {
        return this.$store.getters['listagemContratacaoFrete/searchText'];
      },
      set(searchText) {
        this.$store.dispatch('listagemContratacaoFrete/searchText', searchText);
      },
    },
  },
  methods: {
    emitChange() {
      this.$emit('change');
    },
  },
};
</script>
